import React from 'react';
import { Search } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const SearchInput = ({ value, onChange }: Props) => {
  const { translations } = useLanguage();

  return (
    <div className="flex-1 min-w-[200px]">
      <div className="relative">
        <input
          type="text"
          placeholder={
            translations?.searchInput?.placeholder ||
            'Search by pilgrim name or passport number...'
          }
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border rounded-lg text-right
                   focus:ring-2 focus:ring-primary-500 transition-all"
        />
        <Search
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          size={20}
        />
      </div>
    </div>
  );
};
